import React, { useState, useEffect } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditProtectionTierDrawer = ({ isOpen, onClose, tier, onUpdate }) => {
  const [formData, setFormData] = useState({
    min_value: "",
    max_value: "",
    rate: "",
  });

  useEffect(() => {
    if (tier) {
      setFormData({
        min_value: tier.min_value ?? "",
        max_value: tier.max_value ?? "",
        rate: tier.rate ?? "",
      });
    }
  }, [tier]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    onUpdate({
      ...tier,
      ...formData,
      min_value: Number(formData.min_value),
      max_value: Number(formData.max_value),
      rate: Number(formData.rate),
    });
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit Protection Tier</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Min Value"
            name="min_value"
            type="number"
            value={formData.min_value}
            onChange={handleChange}
            placeholder="Enter min value"
          />

          <ReusableInput
            label="Max Value"
            name="max_value"
            type="number"
            value={formData.max_value}
            onChange={handleChange}
            placeholder="Enter max value"
          />

          <ReusableInput
            label="Rate"
            name="rate"
            type="number"
            value={formData.rate}
            onChange={handleChange}
            placeholder="Enter rate"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>

          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditProtectionTierDrawer;